import { API_FAIL, API_SUCCESS } from '../common/actionTypes';
import {
  ADD_NOTIFICATION,
  DELETE_NOTIFICATION,
  EDIT_NOTIFICATION,
  GET_ALL_NOTIFICATIONS,
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_SETTINGS,
  GET_UNREAD_COUNT,
  MARK_NOTIFICATION_READ,
  SET_NOTIFICATIONS_SETTINGS,
  SET_NOTIFICATION_SETTINGS_LOADING,
} from './actionTypes';

const INIT_STATE = {
  notifications: {},
  adminNotifications: [],
  currentItemId: null,
  notificationSettings: [],
  loading: false,
  unreadCount: 0,
  prevUnreadCount: 0,
};

const Notifications = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_NOTIFICATIONS_SETTINGS:
      return {
        ...state,
        loading: true,
      };
    // Optimistic mark-as-read: fires the instant the action is dispatched (before
    // the POST round-trip) so the highlight clears and the badge decrements with no
    // perceptible lag. The 30s unread-count poll reconciles if the POST ultimately
    // fails — no explicit rollback needed for this low-stakes action.
    case MARK_NOTIFICATION_READ:
      return {
        ...state,
        unreadCount: Math.max(0, state.unreadCount - 1),
        notifications: {
          ...state.notifications,
          items: (state.notifications?.items || []).map((item) =>
            item.id === action.payload ? { ...item, is_read: true } : item
          ),
        },
      };
    case API_SUCCESS:
      switch (action.payload.actionType) {
        case GET_NOTIFICATIONS:
          return {
            ...state,
            notifications: action.payload.data,
          };
        case GET_ALL_NOTIFICATIONS:
          return {
            ...state,
            adminNotifications: action.payload.data,
          };
        case ADD_NOTIFICATION:
          return {
            ...state,
            notifications: state?.notifications?.length
              ? [...state?.notifications, action.payload.data]
              : [],
          };
        case EDIT_NOTIFICATION:
          return {
            ...state,
            notifications: state.notifications.map((item) => {
              if (item.id === action.payload.data.id) {
                return action.payload.data;
              }
              return item;
            }),
          };

        case DELETE_NOTIFICATION:
          return {
            ...state,
            notifications: state.notifications.filter((item) => item.id !== action.payload.data),
          };

        case GET_NOTIFICATIONS_SETTINGS:
          return {
            ...state,
            notificationSettings: action.payload.data,
          };

        case SET_NOTIFICATIONS_SETTINGS:
          return {
            ...state,
            loading: false,
          };

        case GET_UNREAD_COUNT:
          return {
            ...state,
            prevUnreadCount: state.unreadCount,
            unreadCount: action.payload.data.count,
          };

        default:
          return state;
      }
    case API_FAIL:
      switch (action.payload.actionType) {
        case GET_NOTIFICATIONS:
          return {
            ...state,
            notificationsError: action.payload.error,
          };
        case SET_NOTIFICATIONS_SETTINGS:
          return {
            ...state,
            loading: false,
          };
        case GET_UNREAD_COUNT:
          // A failed poll must not modify unreadCount or prevUnreadCount
          return state;
        // MARK_NOTIFICATION_READ failure: no rollback — the optimistic update
        // stands and the 30s unread-count poll reconciles. Falls through to default.
        default:
          return state;
      }
    default:
      return state;
  }
};

export default Notifications;
